<div class="hierarchy-checker-container">
  <span class="air-heading">Run Hierarchy Checker Command</span>
  <div class="ml-20">
  <p class="description">
    This update Hierarchy Checker command relies on an external application and may require several minutes to process.
  </p>
  
  <div *ngIf="responseMessage" class="response-message" [ngClass]="{'success': isSuccess}">
    <h3>Hierarchy Checker - {{ isSuccess ? 'Success' : 'Error' }}</h3>
    <p>{{ responseMessage }}</p>
  </div>
  
  <div class="button-container">
    <button pButton type="button" label="Run Hierarchy Checker" class="p-button-primary" 
            [disabled]="isProcessing" 
            (click)="runHierarchyChecker()"></button>
  </div>
</div>
</div>
